import { Preset } from "shared-ts/libs/dates/presets"

import { classNames } from "../../../lib/classNames"

interface TimestampRangePickerPresetSidebarProps {
  selectedPreset: Preset | null
  presetsToDisplay: Preset[]
  onSelectPreset: (preset: Preset) => void
}

export function TimestampRangePickerPresetSidebar({
  selectedPreset,
  presetsToDisplay,
  onSelectPreset,
}: TimestampRangePickerPresetSidebarProps) {
  return (
    <div className="border-l-v2-border-default -my-4 flex flex-col gap-y-4 border-l p-4">
      {presetsToDisplay.map((preset) => {
        return (
          <div
            key={preset.id}
            className={classNames(
              selectedPreset?.id === preset.id
                ? "text-v2-foreground-primary text-body-strong"
                : "text-v2-foreground-default-weak hover:text-v2-foreground-default",
              "text-body cursor-pointer whitespace-nowrap"
            )}
            data-testid={`${preset.id}-date-range-picker`}
            onMouseDown={() => onSelectPreset(preset)}
          >
            {preset.displayText}
          </div>
        )
      })}
    </div>
  )
}
